import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  RemoveRecipientBankAccountEntity,
  RecipientBankAccountService,
} from 'services/openapi';

import { RecipientBankAccountQueryKeys } from '../constants';

export const useDeleteAccountBankMutation = () => {
  const queryClient = useQueryClient();

  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<RemoveRecipientBankAccountEntity, Error, string>({
      mutationFn: (recipientBankAccountId: string) =>
        RecipientBankAccountService.recipientBankAccountControllerRemove(
          recipientBankAccountId,
        ),
      onSuccess: () =>
        queryClient.invalidateQueries([
          RecipientBankAccountQueryKeys.GET_OWN_LIST,
        ]),
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
